<template>
    <tr :data-href="url">
        <td>{{ fileName }}</td>
        <td>{{ formattedSize }}</td>
        <td>{{ formattedDate }}</td>
        <td data-prevent-click>{{ user.username }}</td>

        <td v-if="canDelete" data-prevent-click>
            <a @click="onDelete(index)" class="btn-a" title="Delete">&times;</a>
        </td>
        <td v-else data-prevent-click>
            <a class="btn-a disabled" title="Delete (No Permission)">&times;</a>
        </td>
    </tr>
</template>

<script>
const dateFns = require('date-fns');

const { format, parse } = dateFns;

export default {
    name: "EnqUpload",

    props: {
        url: {
            required: true,
            type: String
        },

        fileName: {
            required: true,
            type: String
        },

        fileSize: {
            required: true,
            type: Number
        },

        dateTime: {
            required: true,
            type: String
        },

        user: {
            required: true,
            type: Object
        },

        index: {
            required: true,
            type: Number
        },

        canDelete: {
            required: true,
            type: Boolean
        },

        onDelete: {
            required: true,
            type: Function
        }
    },

    data() {
        return {};
    },

    computed: {
        formattedDate() {
            const p = parse(
                this.dateTime,
                "yyyy-MM-dd HH:mm:ss",
                new Date()
            );

            return p.toLocaleDateString() + ' @ ' + format(p, 'HH:mm:ss');
        },

        formattedSize() {
            return byte_format(this.fileSize);
        }
    },

    methods: {},

    watch: {},

    mounted() {
        make_tables_clickable();
    }
};
</script>
